import { Navigate } from "react-router-dom";
import Login from "../pages/Auth/Login";
import PrivateOutlet from "./private-outlet";
import MainLayout from "../pages/MainLayout";
import ContractList from "../pages/ContractList/ContractList";
import TemplateContract from "../pages/templateContract/TemplateContract";
import { User } from "../pages/User/User";
import { Money } from "../pages/Money/Money";
import SingByCustomer from "../pages/SignByCustomer/SignByCustomer";
import ContractUploaded from "../pages/ContractUploaded/ContractUploaded";

let MainRoutes = [
  { path: "/", element: <Navigate to="/danh-sach-hop-dong" replace /> },
  { path: "/login", element: <Login /> },
  {
    path: "/customer-login/",
    element: <SingByCustomer />,
  },
  { path: "/logout", element: <Login /> },
  {
    path: "",
    element: <PrivateOutlet />,
    children: [
      {
        path: "",
        element: <MainLayout />,
        children: [
          { path: "/danh-sach-hop-dong", element: <ContractList /> },
          {
            path: "/danh-sach-hop-dong-tai-len",
            element: <ContractUploaded />,
          },
          { path: "/ql-hop-dong", element: <TemplateContract /> },
          { path: "/ql-tai-khoan", element: <User /> },
          { path: "/ql-chi-phi-khoa-hoc", element: <Money /> },
        ],
      },
    ],
  },
];

export default MainRoutes;
